module.exports = __webpack_public_path__ + "media/icons/search-91b06151.png";